/**
 * Pure display helpers for the Feature Adoption panel.
 */

/** 0.6667 -> "67%"; null -> "—" (nothing decided yet). */
export function formatPct(rate: number | null | undefined): string {
  if (rate == null || Number.isNaN(rate)) return '—';
  return `${Math.round(rate * 100)}%`;
}

/** Milliseconds -> "850 ms" / "2.3 s"; null -> "—". */
export function formatMs(ms: number | null | undefined): string {
  if (ms == null || Number.isNaN(ms)) return '—';
  if (ms < 1000) return `${Math.round(ms)} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
}

/** Traffic-light class key for a success rate. */
export function rateTone(rate: number | null | undefined): 'good' | 'warn' | 'bad' | 'none' {
  if (rate == null || Number.isNaN(rate)) return 'none';
  if (rate >= 0.9) return 'good';
  if (rate >= 0.7) return 'warn';
  return 'bad';
}

/** "2026-09-26" -> "Sep 26" (UTC day keys, no timezone shift). */
export function formatDay(day: string): string {
  const [y, m, d] = day.split('-').map(Number);
  if (!y || !m || !d) return day;
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

/** ISO timestamp -> "Sep 26, 09:41"; null -> "—". */
export function formatWhen(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** Snake-case identifiers read better as words: "order_update" -> "order update". */
export function humanize(id: string): string {
  return id.replace(/_/g, ' ');
}
